import request from "@/router/axios";

/**
 * 查询所有菜品/商品/辅料基本信息
 */
export function findAll(data) {
  return request({
    url: `/metMaterial/met/findAll`,
    method: "post",
    data,
  });
}

/**
 *
 * @param {*} data
 * @returns
 */
export function findAllWithCookTech(data) {
  return request({
    url: `/metMaterial/met/findAllWithCookTech`,
    method: "post",
    data,
  });
}

/**
 * 新建/编辑 商品 提交
 */
export function saveOrUpdate(data) {
  return request({
    url: `/metMaterial/metGoods/saveOrUpdate`,
    method: "post",
    data,
  });
}

/**
 * 回显
 */
export function findGoodsDetail(id) {
  return request({
    url: `/metMaterial/metGoods/detail?goodsId=${id}`,
    method: "get",
  });
}

/**
 * 新列表查询
 */
export function findPage(page, size, data) {
  return request({
    url: `/metMaterial/metGoods/page?page=${page}&size=${size}`,
    method: "post",
    data,
  });
}

/**
 * 获取菜单分类
 * @returns
 */
export function findMenuType() {
  return request({
    url: `/metMaterial/metGoods/findMenuType`,
    method: "get",
  });
}

/**
 * 获取树形结构
 * @returns
 */
export function metmaterialMetFindmenutree(type) {
  return request({
    url: `/metMaterial/met/findMenuTree?type=${type}`,
    method: "get",
  });
}

/**
 * 获取套餐的固定规格和可选规格
 * @param {*材料id } materialId
 * @param {*固定/可选规格 } fixed 
 * 固定-1  可选-0
 * @returns 
 */
export function metmaterialMetCombFindattrlist(materialId, fixed) {
  return request({
    url: `/metMaterial/met/comb/findAttrList?combGoodsId=${materialId}&fixed=${fixed}`,
    method: "get",
  });
}

/**
 * 添加 - 编辑固定 / 可选规格
 * @param {*} data
 * @returns
 */
export function metmaterialMetCombAttrCreateorupdate(data) {
  return request({
    url: `/metMaterial/met/comb/attr/createOrUpdate`,
    method: "post",
    data,
  });
}

/**
 * 删除 - 编辑固定 / 可选规格 
 * @param {*} id 
 * @returns 
 */
export function metmaterialMetCombAttrDelete(id) {
  return request({
    url: `/metMaterial/met/comb/attr/delete?id=${id}`,
    method: "get",
  });
}

/**
 * 添加 /编辑 - 规格值
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetCombAttrvalCreateorupdate(data) {
  return request({
    url: `/metMaterial/met/comb/attrVal/createOrUpdate`,
    method: "post",
    data,
  });
}

/**
 * 删除- 规格值
 * @param {*} id
 * @returns 
 */
export function metmaterialMetCombAttrvalDelete(id) {
  return request({
    url: `/metMaterial/met/comb/attrVal/delete?id=${id}`,
    method: "get",
  });
}

/**
 * 获取规格组合值列表
 * @param {*} id 
 * @returns 
 */
export function metmaterialMetCombSkuPermutation(id) {
  return request({
    url: `/metMaterial/met/comb/sku/permutation?combGoodsId=${id}`,
    method: "get",
  });
}

/**
 * 提交规格组合值列表
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetCombSkuPermutationCombgoodsidId(data) {
  return request({
    url: `/metMaterial/met/comb/sku/createOrUpdate`,
    method: "post",
    data
  });
}

/**
 * 根据id查询规格值详情
 * @param {*} id 
 * @returns 
 */
export function metmaterialMetCombAttrvalFind(id) {
  return request({
    url: `/metMaterial/met/comb/attrVal/find?id=${id}`,
    method: "get",
  });
}

/**
 * 根据id查询规格详情
 * @param {*} id 
 * @returns 
 */
export function metmaterialMetCombAttrFind(id) {
  return request({
    url: `/metMaterial/met/comb/attr/find?id=${id}`,
    method: "get",
  });
}

/**
 * 查询复制接口
 * @param {*} data 
 * @returns 
 */ 
export function metmaterialMetCombSearchattr(data) {
  return request({
    url: `/metMaterial/met/comb/searchAttr?page=${data.page - 1}&size=${data.size}`,
    method: "post",
    data
  });
}

/**
 * 提交复制
 * @param {*} data 
 * @returns 
 */ 
export function metmaterialMetCombCpoy(data) {
  return request({
    url: `/metMaterial/met/comb/copy`,
    method: "post",
    data
  });
}

/**
 * 查询现在已有的规格组合
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetCombKuFindall(id) {
  return request({
    url: `/metMaterial/met/comb/sku/findAll?combGoodsId=${id}`,
    method: "get",
  });
}


/**
 * 分页查询pos商品 / 查询店内商品
 * @param {*} data 
 * @returns 
 */
export function foodmacadminThirdpartyplatformKryGoodsSynckryshopallgoods(data) {
  return request({
    url: `/foodMacAdmin/thirdPartyPlatform/kry/goods/syncKryShopAllGoods`,
    method: "post",
    data
  });
}

/**
 * 分页查询pos商品 / 查询店内商品
 * @param {*} data 
 * @returns 
 */
export function metmaterialThirdpartyplatformKryGoodsSearchdish(data) {
  return request({
    url: `/metMaterial/thirdPartyPlatform/kry/goods/searchDish?page=${data.page - 1}&size=${data.size}`,
    method: "post",
    data
  });
}

/**
 * 远程搜索pos门店
 * @param {*} data 
 * @returns 
 */
export function metmaterialThirdpartyplatformKryShopSearch(data) {
  return request({
    url: `/metMaterial/thirdPartyPlatform/kry/shop/search`,
    method: "post",
    data
  });
}

/**
 * 提交关联商品弹窗
 * @param {*} data 
 * @returns 
 */
export function metmaterialThirdpartyplatformKryGoodsBinddish(data) {
  return request({
    url: `/metMaterial/thirdPartyPlatform/kry/goods/bindDish`,
    method: "post",
    data
  });
}

/**
 * 解绑提交
 * @param {*} data 
 * @returns 
 */
export function metmaterialThirdpartyplatformKryGoodsUnbinddish(data) {
  return request({
    url: `/metMaterial/thirdPartyPlatform/kry/goods/unBindDish`,
    method: "post",
    data
  });
}

/**
 * 自动关联pos商品
 * @param {*} data 
 * @returns 
 */
export function metmaterialThirdpartyplatformKryGoodsBindalldish(data) {
  return request({
    url: `/metMaterial/thirdPartyPlatform/kry/goods/bindAllDish`,
    method: "post",
    data
  });
}

/**
 * 提交店铺组网模式
 * @param {*} data 
 * @returns 
 */
export function foodmacsiteSiteIotCreate(data) {
  return request({
    url: `/foodmacsite/site/iot/create`,
    method: "post",
    data
  });
}

/**
 * 切换为云端直连
 * @param {*} data 
 * @returns 
 */
export function foodmacsiteSiteUpdatenetworkmode(data) {
  return request({
    url: `/foodmacsite/site/updateNetworkMode`,
    method: "post",
    data
  });
}

/**
 * 查询
 * @param {*} data 
 * @returns 
 */
export function foodmacsiteSiteIotFind(id) {
  return request({
    url: `/foodmacsite/site/iot/find?siteId=${id}`,
    method: "get"
  });
}

/**
 * 查询
 * @param {*} data 
 * @returns 
 */
export function foodmacsiteSiteFindconnectstatus(id) {
  return request({
    url: `/foodmacsite/site/findConnectStatus?siteId=${id}`,
    method: "get"
  });
}

/**
 * 查询列表
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetFindsortlist (menuType) {
  return request({
    url: `/metMaterial/met/findSortList?menuType=${menuType}`,
    method: 'get',
  })
}

/**
 * 商品排序修改
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetUpdatesort (data) {
  return request({
    url: `/metMaterial/met/updateSort`,
    method: 'post',
    data
  })
}

/**
 * 回显进货价弹窗
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetgoodsCostpriceSelectlist (v) {
  return request({
    url: `/metMaterial/metGoods/costPrice/selectList?goodsId=${v.goodsId}`,
    method: 'get',
  })
}

/**
 * 提交进货价表单
 * @param {*} data 
 * @returns 
 */
export function metmaterialMetgoodsCostpriceCreate (data) {
  return request({
    url: `/metMaterial/metGoods/costPrice/create`,
    method: 'post',
    data
  })
}